export default __webpack_public_path__ + "static/media/photoshop.2b2f2e16.svg";